import React from "react";

import { IStringOption } from "../input/StringOptionSelect";
import { ControllerStringOptionSelect } from "./ControllerStringOptionSelect";
import { FormInputWrapper } from "./FormInputWrapper";

interface IProps {
    label: string;
    name: string;
    options: IStringOption[];

    placeholder?: string;
    required?: boolean;
}

/**
 * @deprecated Just directly use FormInputWrapper and ControllerStringOptionSelect.
 */
export const FormStringOptionSelect: React.FC<IProps> = ({ label, name, options, placeholder, required }) => {
    return (
        <FormInputWrapper name={name} required={required} label={label}>
            <ControllerStringOptionSelect
                name={name}
                controllerProps={{ rules: { required } }}
                required={required}
                placeholder={placeholder}
                options={options}
            />
        </FormInputWrapper>
    );
};
